interface PricingAnnualProps {
  css?: any;
}

const PricingAnnualSvg = ({ ...props }: PricingAnnualProps) => {
  return (
    <svg
      width="115"
      height="98"
      viewBox="0 0 115 98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_1183_104821"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="115"
        height="98"
      >
        <path
          d="M0 0H105C110.523 0 115 4.47715 115 10V98H0V0Z"
          fill="#F4F6FD"
        />
      </mask>
      <g mask="url(#mask0_1183_104821)">
        <ellipse cx="110.5" cy="-13" rx="107.5" ry="107" fill="#55D278" />
      </g>
    </svg>
  );
};

export default PricingAnnualSvg;
